export default function getColorComponent(color) {
    if (!color || color === "transparent")
        return "primary";
    const m = color.match(/^(.*)-(\d+)$/);
    if (m) {
        return m[1];
    }
    return color;
}
//# sourceMappingURL=get-color-component.js.map